.scrollable {
  overflow: auto;
  background-color: var(--main-background);
  flex: 1;
}

.row {
  display: flex;
  padding-top: 20px;
}

.content {
  width: 100%;
  margin: 0 20px;
}
